module.exports = __webpack_public_path__ + "static/media/logo1_mini.3a4bfaaf.svg";